import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BlogList from '../components/BlogList';
import useScrollFadeIn from '../components/useScrollFadeIn.js';
import githubIcon from '../assets/icons/github.svg';


function Blog() {
    const { t } = useTranslation();
    
    const [HeaderRef, HeaderVisible] = useScrollFadeIn();
    const [BlogListRef, BlogListVisible] = useScrollFadeIn();

    useEffect(() => {
        const shouldScroll = sessionStorage.getItem('scrollToContact');
        if (shouldScroll === 'true') {
            const contactSection = document.getElementById('contact');
            if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
            }
            sessionStorage.removeItem('scrollToContact');
        }
    }, []);

    return (
        <div className="Blogs-wrapper container mt-5">
            <div className="row justify-content-center">
                <div className="col-11 px-2 px-md-1">

                    {/* Header-osio */}
                    <div className="header-section mb-5">
                        <div
                            ref={HeaderRef}
                            className={`fade-in-section ${HeaderVisible ? 'visible' : ''}`}
                        >
                            <h1 className='header-name mb-4 mb-md-5'>{t('Blog.headerTitle')}</h1>
                            <p className='subtext'>{t('Blog.headerDescription')}</p>
                            <br />
                            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
                                <img src={githubIcon} alt="Github" />
                                <a href="https://github.com/AkseliRaj" target="_blank" rel="noopener noreferrer">{t('Blog.githubLinkText')}</a>
                            </div>
                        </div>
                    </div>

                    {/* Blogi-lista */}
                    <div className="blog-list-section">
                        <div
                            ref={BlogListRef}
                            className={`fade-in-section ${BlogListVisible ? 'visible' : ''}`}
                        >
                            <h1 className='header-name mb-4 mb-md-5'>2025</h1>
                            <BlogList />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Blog;